module.exports = __webpack_public_path__ + "static/media/doclad9.dac671f2.pdf";